import { render, staticRenderFns } from "./FormatTable.vue?vue&type=template&id=3c96fb58&"
import script from "./FormatTable.vue?vue&type=script&lang=ts&"
export * from "./FormatTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports